import { FormatDataService } from '../services/format-data.service';
//Format Time with momentJS
import * as moment from 'moment'

export class GridDataModel {
  EmployeeID: number = null;
  EmployeeName: string = null;
  RequestStatusID: number = null;
  RequestStatusCode: string = null;
  WorkStoreID: number = null;
  PRARequestID: number = null;
  IsCancelled: boolean = null;
  RequestorEmployeeID: number = null;
  RequestorEmployeeName: string = null;
  DateCreated: any = null;
  State: string = null;
  RegionCode: string = null;
  HomeStore: string = null;
  Comments: string = null;
  Total: any = null;
  SelectedWeek: any = null;
  DailyTotalHours: any = null;
  BusinessDate: any = null;

  constructor(data) {
    this.EmployeeID = data.EmployeeID;
    this.EmployeeName = data.EmployeeName;
    this.RequestStatusID = data.RequestStatusID;
    this.RequestStatusCode = data.RequestStatusCode;
    this.WorkStoreID = data.WorkStoreID;
    this.PRARequestID = data.PRARequestID;
    this.IsCancelled = data.IsCancelled;
    this.RequestorEmployeeID = data.RequestorEmployeeID;
    this.RequestorEmployeeName = data.RequestorEmployeeName;
    this.DateCreated = moment(data.DateCreated).format('YYYY/MM/DD');
    this.State = data.State;
    this.RegionCode = data.RegionCode;
    this.HomeStore = data.HomeStore;
    this.Comments = data.Comments;
    this.Total = this.formatMinutesToHours(data.Total);
    this.SelectedWeek = moment(data.SelectedWeek).format('YYYY/MM/DD');
    this.DailyTotalHours = this.formatMinutesToHours(data.DailyTotal);
    this.BusinessDate = moment(data.BusinessDate).format('YYYY/MM/DD');
  }

  formatMinutesToHours(minutes) {
    var minutes = minutes;
    var hours = (minutes / 60).toFixed(2);
    return hours;
  }
}
